import type { ITooDiagnosticReportCustomControlData } from '@common/interfaces/ophthalmology/TOO/tooDiagnosticReportCustomControlData';

export function tooV1DiagnosticReportInitializeCustomControlData(): ITooDiagnosticReportCustomControlData {
    return {
        afwijking_in_ao: {
            glasvocht: false,
            glasvochtAndersText: null,
            glasvochtOd_andersCheck: false,
            glasvochtOd_exfoliatie: false,
            glasvochtOd_glasvochtbloeding: false,
            glasvochtOd_glasvochtloslating: false,
            glasvochtOd_mouchesVolantes: false,
            glasvochtOd_tobaccoDust: false,
            glasvochtOs_andersCheck: false,
            glasvochtOs_exfoliatie: false,
            glasvochtOs_glasvochtbloeding: false,
            glasvochtOs_glasvochtloslating: false,
            glasvochtOs_mouchesVolantes: false,
            glasvochtOs_tobaccoDust: false,
            macula: false,
            maculaAndersText: null,
            maculaOd_andersCheck: false,
            maculaOd_bloeding: false,
            maculaOd_drusen: false,
            maculaOd_macula_degeneratie: false,
            maculaOd_maculopathie: false,
            maculaOd_oedeem: false,
            maculaOd_pigmentepitheel_alteraties: false,
            maculaOd_pucker: false,
            maculaOs_andersCheck: false,
            maculaOs_bloeding: false,
            maculaOs_drusen: false,
            maculaOs_macula_degeneratie: false,
            maculaOs_maculopathie: false,
            maculaOs_oedeem: false,
            maculaOs_pigmentepitheel_alteraties: false,
            maculaOs_pucker: false,
            papil: false,
            papilAndersText: null,
            papilOd_andersCheck: false,
            papilOd_excavatie: false,
            papilOd_glaucoomsuspect: false,
            papilOd_neovascularisatie: false,
            papilOd_oedeem: false,
            papilOd_peripapillaireAtrofie: false,
            papilOd_tilted: false,
            papilOd_vlamvormigeBloeding: false,
            papilOs_andersCheck: false,
            papilOs_excavatie: false,
            papilOs_glaucoomsuspect: false,
            papilOs_neovascularisatie: false,
            papilOs_oedeem: false,
            papilOs_peripapillaireAtrofie: false,
            papilOs_tilted: false,
            papilOs_vlamvormigeBloeding: false,
            perifere_retina: false,
            perifere_retinaAndersText: null,
            perifere_retinaOd_IRMA: false,
            perifere_retinaOd_PEA: false,
            perifere_retinaOd_ablatio: false,
            perifere_retinaOd_andersCheck: false,
            perifere_retinaOd_arterieleStamocclusie: false,
            perifere_retinaOd_arterieleTakocclusie: false,
            perifere_retinaOd_atherosclerosis: false,
            perifere_retinaOd_beading: false,
            perifere_retinaOd_bloeding: false,
            perifere_retinaOd_cottonWoolSpots: false,
            perifere_retinaOd_drusen: false,
            perifere_retinaOd_exsudaten: false,
            perifere_retinaOd_hypertensieveRetinopathie: false,
            perifere_retinaOd_latticeDegeneratie: false,
            perifere_retinaOd_microaneurysma: false,
            perifere_retinaOd_naevus: false,
            perifere_retinaOd_neovascularisatie: false,
            perifere_retinaOd_netvliesdefect: false,
            perifere_retinaOd_netvliesscheur: false,
            perifere_retinaOd_venaStamocclusie: false,
            perifere_retinaOd_venaTakocclusie: false,
            perifere_retinaOs_IRMA: false,
            perifere_retinaOs_PEA: false,
            perifere_retinaOs_ablatio: false,
            perifere_retinaOs_andersCheck: false,
            perifere_retinaOs_arterieleStamocclusie: false,
            perifere_retinaOs_arterieleTakocclusie: false,
            perifere_retinaOs_atherosclerosis: false,
            perifere_retinaOs_beading: false,
            perifere_retinaOs_bloeding: false,
            perifere_retinaOs_cottonWoolSpots: false,
            perifere_retinaOs_drusen: false,
            perifere_retinaOs_exsudaten: false,
            perifere_retinaOs_hypertensieveRetinopathie: false,
            perifere_retinaOs_latticeDegeneratie: false,
            perifere_retinaOs_microaneurysma: false,
            perifere_retinaOs_naevus: false,
            perifere_retinaOs_neovascularisatie: false,
            perifere_retinaOs_netvliesdefect: false,
            perifere_retinaOs_netvliesscheur: false,
            perifere_retinaOs_venaStamocclusie: false,
            perifere_retinaOs_venaTakocclusie: false,
        },
        afwijking_in_vo: {
            conjunctiva: false,
            conjunctivaAndersText: null,
            conjunctivaOd_andersCheck: false,
            conjunctivaOd_chemosis: false,
            conjunctivaOd_follikels: false,
            conjunctivaOd_hyperemie: false,
            conjunctivaOd_papillen: false,
            conjunctivaOd_roodheid: false,
            conjunctivaOd_subconjunctivaleBloeding: false,
            conjunctivaOs_andersCheck: false,
            conjunctivaOs_chemosis: false,
            conjunctivaOs_follikels: false,
            conjunctivaOs_hyperemie: false,
            conjunctivaOs_papillen: false,
            conjunctivaOs_roodheid: false,
            conjunctivaOs_subconjunctivaleBloeding: false,
            cornea: false,
            corneaAndersText: null,
            corneaOd_andersCheck: false,
            corneaOd_corneadystrofie: false,
            corneaOd_erosie: false,
            corneaOd_fuchs: false,
            corneaOd_guttata: false,
            corneaOd_infiltraat: false,
            corneaOd_keratoconus: false,
            corneaOd_krukenbergSpindle: false,
            corneaOd_mapDotFingerprintDystrofie: false,
            corneaOd_neovascularisatie: false,
            corneaOd_oedeem: false,
            corneaOd_pterygium: false,
            corneaOd_punctata: false,
            corneaOd_ulcus: false,
            corneaOs_andersCheck: false,
            corneaOs_corneadystrofie: false,
            corneaOs_erosie: false,
            corneaOs_fuchs: false,
            corneaOs_guttata: false,
            corneaOs_infiltraat: false,
            corneaOs_keratoconus: false,
            corneaOs_krukenbergSpindle: false,
            corneaOs_mapDotFingerprintDystrofie: false,
            corneaOs_neovascularisatie: false,
            corneaOs_oedeem: false,
            corneaOs_pterygium: false,
            corneaOs_punctata: false,
            corneaOs_ulcus: false,
            iris: false,
            irisAndersText: null,
            irisOd_andersCheck: false,
            irisOd_diafanie: false,
            irisOd_naevus: false,
            irisOd_rubeosis: false,
            irisOs_andersCheck: false,
            irisOs_diafanie: false,
            irisOs_naevus: false,
            irisOs_rubeosis: false,
            lens: false,
            lensAndersText: null,
            lensOd_andersCheck: false,
            lensOd_cataract_beginnend: false,
            lensOd_cataract_storend: false,
            lensOd_lenssclerose: false,
            lensOd_nastaar: false,
            lensOd_pseudoexfoliate: false,
            lensOd_pseudofaak: false,
            lensOs_andersCheck: false,
            lensOs_cataract_beginnend: false,
            lensOs_cataract_storend: false,
            lensOs_lenssclerose: false,
            lensOs_nastaar: false,
            lensOs_pseudoexfoliate: false,
            lensOs_pseudofaak: false,
            oogleden: false,
            oogledenAndersText: null,
            oogledenOd_MGD: false,
            oogledenOd_andersCheck: false,
            oogledenOd_blepharitis: false,
            oogledenOd_chalazion: false,
            oogledenOd_dermatochalasis: false,
            oogledenOd_ectropion: false,
            oogledenOd_entropion: false,
            oogledenOd_hordeolum: false,
            oogledenOd_ptosis: false,
            oogledenOd_zwelling: false,
            oogledenOs_MGD: false,
            oogledenOs_andersCheck: false,
            oogledenOs_blepharitis: false,
            oogledenOs_chalazion: false,
            oogledenOs_dermatochalasis: false,
            oogledenOs_ectropion: false,
            oogledenOs_entropion: false,
            oogledenOs_hordeolum: false,
            oogledenOs_ptosis: false,
            oogledenOs_zwelling: false,
            vok: false,
            vokAndersText: null,
            vokOd_andersCheck: false,
            vokOd_cellen: false,
            vokOd_tyndall: false,
            vokOs_andersCheck: false,
            vokOs_cellen: false,
            vokOs_tyndall: false,
        },
        conclusie_ao: null,
        conclusie_diagnose: null,
        conclusie_vo: null,
        geadviseerd_beleid: null,
        geadviseerd_beleid_anders: null,
        optometrische_diagnose: {
            cataract: false,
            droge_ogen: false,
            glaucoom: false,
            glaucoom_ja: false,
            glaucoom_nee: false,
            glaucoom_suspect: false,
            macula_degeneratie: false,
            macula_degeneratie_droog: false,
            macula_degeneratie_nat: false,
            macula_degeneratie_suspect: false,
            refractie_problemen: false,
            retinopathie: false,
            retinopathie_diabetische: false,
            retinopathie_overig: false,
        },
        toelichting: null,
        urgentie: null,
    };
}
